const initialState = {
  publicHolidays: [],
};

const holidaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_HOLIDAYS':
      return {
        ...state,
        publicHolidays: action.payload,
      };
    default:
      return { ...state };
  }
};

export default holidaysReducer